import { type Dispatch, useContext } from "react";
import {
  CategoryTreeAction,
  CategoryTreeActions,
  CategoryTreeActionsContext,
  CategoryTreeContext,
  CategoryTreeContextValue,
  CategoryTreeDispatch,
} from "src/contexts/category-tree-context";

export function useCategoryTreeContext(): CategoryTreeContextValue {
  const categoryTreeContext = useContext(CategoryTreeContext);

  if (!categoryTreeContext) {
    throw new Error(
      "Please make sure you use useCategoryTreeContext inside CategoryTreeProvider."
    );
  }

  return categoryTreeContext;
}
export function useCategoryTreeDispatch(): Dispatch<CategoryTreeAction> {
  const categoryTreeDispatch = useContext(CategoryTreeDispatch);

  if (!categoryTreeDispatch) {
    throw new Error(
      "Please make sure you use useCategoryTreeDispatch inside CategoryTreeProvider."
    );
  }

  return categoryTreeDispatch;
}

export function useCategoryTreeActions(): CategoryTreeActions {
  const actions = useContext(CategoryTreeActionsContext);

  if (!actions) {
    throw new Error(
      "Please make sure you use useCategoryTreeActions inside CategoryTreeActionsContext.Provider."
    );
  }

  return actions;
}
